export const collectionPaths = {
  sessions: "sessions",
};
